"use client";

import React, { useRef, useState } from "react";

import { useT } from "@/context/I18nContext"; 

export default function ContactForm() {
     const formRef = useRef();
     const [success, setSuccess] = useState(null);
     const [showMessage, setShowMessage] = useState(false);
     const [isSubmitting, setIsSubmitting] = useState(false);
     const [errorMessage, setErrorMessage] = useState('');
     const [compliance, setCompliance] = useState(false); 

     const { t } = useT(); 

     const handleShowMessage = (message = '') => {
          setErrorMessage(message);
          setShowMessage(true);
          setTimeout(() => {
               setShowMessage(false);
               setErrorMessage('');
          }, 4000);
     };

     const sendMail = async (e) => {
          e.preventDefault();
          
          if(!compliance) {
               handleShowMessage('Te rugăm să accepți prelucrarea datelor personale.');
               return; 
          }

          setIsSubmitting(true);

          try {
               const formData = new FormData(formRef.current);
               const data = {
                    name: formData.get('name')?.trim(),
                    email: formData.get('email')?.trim(),
                    message: formData.get('message')?.trim(),
               };

               // Validare client-side
               if (!data.name || !data.email || !data.message) {
                    handleShowMessage('Toate câmpurile sunt obligatorii');
                    setSuccess(false);
                    setIsSubmitting(false);
                    return;
               }

               const response = await fetch('/api/contact', {
                    method: 'POST',
                    headers: {
                         'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
               });

               const result = await response.json();

               if (response.ok) {
                    setSuccess(true);
                    formRef.current.reset();
                    handleShowMessage('');
               } else {
                    setSuccess(false);
                    handleShowMessage(result.error || 'A apărut o eroare');
               }

          } catch (error) {
               console.error('Error:', error);
               setSuccess(false);
               handleShowMessage('Eroare de conexiune. Te rugăm să reîncerci.');
          } finally {
               setIsSubmitting(false);
          }
     };

     return (
          <section className='flat-spacing-21'>
               <style jsx>{`
                    .auth-field {
                         width: 100%;
                         height: 56px;
                         display: flex;
                         align-items: center;
                         box-sizing: border-box;
                         background: #ffffff;
                         border: 1px solid #d9dde4;
                         border-radius: 28px;
                         overflow: hidden;
                         transition: border-color 0.2s ease, box-shadow 0.2s ease;
                    }
                    .auth-field:focus-within {
                         border-color: #3b82f6;
                         box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
                    }
                    .auth-field input {
                         width: 100%;
                         height: 100%;
                         border: 0;
                         padding: 0 22px;
                         font-size: 15px;
                         background: transparent;
                    }
                    .auth-field input:focus {
                         outline: none;
                    }
                    .auth-textarea {
                         width: 100%;
                         border: 1px solid #d9dde4;
                         border-radius: 24px;
                         padding: 16px 22px;
                         font-size: 15px;
                         transition: border-color 0.2s ease, box-shadow 0.2s ease;
                    }
                    .auth-textarea:focus {
                         outline: none;
                         border-color: #3b82f6;
                         box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
                    }
                    .auth-check {
                         display: flex;
                         align-items: flex-start;
                         gap: 10px;
                         color: #4b5563;
                         font-size: 13px;
                         line-height: 1.5;
                         cursor: pointer;
                    }
                    .auth-check input {
                         width: 17px;
                         height: 17px;
                         margin: 2px 0 0;
                         flex-shrink: 0;
                         accent-color: #3b82f6;
                    }
                    .auth-check :global(a) {
                         color: #3b82f6;
                         text-decoration: underline;
                    }
                    .auth-btn-primary {
                         width: 100%;
                         height: 56px;
                         display: flex;
                         align-items: center;
                         justify-content: center;
                         border: 0;
                         border-radius: 28px;
                         background: #3b82f6;
                         color: #ffffff;
                         font-family: inherit;
                         font-size: 16px;
                         font-weight: 700;
                         cursor: pointer;
                         transition: background 0.18s ease, box-shadow 0.18s ease;
                    }
                    .auth-btn-primary:hover {
                         background: #2563eb;
                         box-shadow: 0 6px 18px rgba(59, 130, 246, 0.18);
                    }
                    .auth-btn-primary:disabled {
                         opacity: 0.6;
                         cursor: not-allowed;
                    }
               `}</style>
               <center>
                    <div className='container'>
                         <div className='tf-grid-layout gap30 lg-col-12' style={{ paddingRight: 300, paddingLeft: 300 }}>
                              <div>
                                   <form
                                        ref={formRef}
                                        onSubmit={sendMail}
                                        className='form-contact'
                                   >
                                        <div className='d-flex gap-15 mb_15'>
                                             <fieldset className='w-100'>
                                                  <div className='auth-field'>
                                                       <input
                                                            type='text'
                                                            name='name'
                                                            required
                                                            placeholder={t("contact_nume")}
                                                            maxLength={100}
                                                            disabled={isSubmitting}
                                                       />
                                                  </div>
                                             </fieldset>
                                             <fieldset className='w-100'>
                                                  <div className='auth-field'>
                                                       <input
                                                            type='email'
                                                            name='email'
                                                            required
                                                            placeholder='Email *'
                                                            maxLength={100}
                                                            disabled={isSubmitting}
                                                       />
                                                  </div>
                                             </fieldset>
                                        </div>
                                        <div className='mb_15'>
                                             <textarea
                                                  className='auth-textarea'
                                                  placeholder={t("contact_mesaj")}
                                                  name='message'
                                                  required
                                                  cols={30}
                                                  rows={10}
                                                  maxLength={2000}
                                                  disabled={isSubmitting}
                                             />
                                        </div>

                                        {showMessage && (
                                             <div className='tfSubscribeMsg active'>
                                                  {success ? (
                                                       <p style={{ color: "rgb(52, 168, 83)" }}>
                                                            ✅ Mesajul a fost trimis cu succes!
                                                       </p>
                                                  ) : (
                                                       <p style={{ color: "red" }}>
                                                            ❌ {errorMessage || 'Oops! Ceva nu a mers bine, te rugăm să reîncerci.'}
                                                       </p>
                                                  )}
                                             </div>
                                        )}

                                        <div className='send-wrap'>
                                             <label className='auth-check mb_15'>
                                                  <input
                                                       type='checkbox'
                                                       name='compliance'
                                                       checked={compliance}
                                                       onChange={(e) => setCompliance(e.target.checked)}
                                                  />
                                                  <span>
                                                       {t("contact_bifa")}
                                                       <a href="/politica-de-confidentialitate">{t("politica_de_confidentialitate")}</a>.
                                                  </span>
                                             </label>
                                             <button
                                                  type='submit'
                                                  className='auth-btn-primary'
                                                  disabled={isSubmitting}
                                             >
                                                  {isSubmitting ? t("contact_button_sending") : t("contact_button")}
                                             </button>
                                        </div>
                                   </form>
                              </div>
                         </div>
                    </div>
               </center>
          </section>
     );
}